import React, { useEffect, useState, useRef } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import api from '../../../api';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Toast } from 'primereact/toast';


function GetGoingActivity_7() {
  const userID = sessionStorage.getItem("UserID");
  const [data, setData] = useState([]);
  const currentDate1 = new Date();
  const dt = useRef(null);
  const toast = useRef(null);
  const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
  const getGoingActivityData = async () => {

    try {

      const requestData = {
        logged_in_userid: userID,
        table_name: "trn_tbl_fu_status",
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W"
      };


      const result = await api.get_Raw_Data(requestData)
      const responseData = result.trn_tbl_fu_status;

      const slNo = responseData.map((item, index) => ({
        ...item, slno: index + 1
      }));

      setData(slNo)

    } catch (error) {
      console.error("Error get going activity keep doing activity selection data", error);
      toast.current.show({
        severity: "info",
        summary: "No Data Found",
        detail: "There is no data for this table"
      });

    }

  }

  const cleanValue = (value) => {
    if (value === "-999" || value === -999) return "";

    if (typeof value === "string" && value.includes("$")) {
      return value.split("$").join(",");
    }

    return value;
  };


  const exportData = data.map(item => ({
    "SlNo": item.slno,
    "State": cleanValue(item.fld_state_name),
    "District": cleanValue(item.fld_district_name),
    "Site": cleanValue(item.fld_site_name),
    "Taluk": cleanValue(item.fld_taluk_name),
    "Village": cleanValue(item.fld_village_name),
    "PHC": cleanValue(item.fld_phc_name),
    "Participant Name": cleanValue(item.fld_participant_name),
    "Participant ID": cleanValue(item.fld_participant_id),
    "FU Visit Date": cleanValue(item.fld_fu_visit_date),
    "FU Visit Number": cleanValue(item.fld_fu_visit_number),
    "FU Done by": cleanValue(item.fld_fu_done_by),
    "Pleasurable Activities": cleanValue(item.fld_pleasurable_activity_name),
    "Accomplishment Activities": cleanValue(item.fld_accomplishment_activity_name),
    "Loggedin User ID": cleanValue(item.fld_loggedin_user_id),
        "System Inserted Date": item.fld_system_inserted_datetime
          ? new Date(item.fld_system_inserted_datetime).toISOString().split("T")[0]
          : "", // fallback in case value is missing
  }));

  const handleDownloadCSV = () => {
    if (!data || data.length === 0) {
      console.warn("No data available to export");
      return;
    }

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `KeepDoing_Activity_raw_Data`);

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "csv",
      type: "array"
    });

    // Create Blob and trigger download
    const dataBlob = new Blob([excelBuffer], { type: "text/csv;charset=utf-8;" });
    saveAs(dataBlob, "KeepDoing_Activity_Data.csv");
  };



  useEffect(() => {
    getGoingActivityData();
  }, []);

  return (
    <div>
      <Toast ref={toast} position="top-right" />

      <span className='flex justify-content-end mt-2 mb-4'>
        <Button className="downloadbutton"
          label='Download CSV'
          icon="pi pi-download"
          onClick={handleDownloadCSV}
        />
      </span>
      <DataTable
        value={data}
        scrollHeight="350px"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        ref={dt}
        scrollable
      >
        <Column field="slno" header="Sl.No" body={(rowData) => cleanValue(rowData.slno)} />
        <Column field="fld_phc_name" header="PHC Name" body={(rowData) => cleanValue(rowData.fld_phc_name)} />
        <Column field="fld_loggedin_user_id" header="User ID" />
        <Column field="fld_participant_name" header="Participent Name" body={(rowData) => cleanValue(rowData.fld_participant_name)} />
        <Column field="fld_participant_id" header="Participent ID" body={(rowData) => cleanValue(rowData.fld_participant_id)} />
        <Column field="fld_fu_visit_date" header="FU Visit Date" body={(rowData) => cleanValue(rowData.fld_fu_visit_date)} />
        <Column field="fld_fu_visit_number" header="FU Visit Number" body={(rowData) => cleanValue(rowData.fld_fu_visit_number)} />
        <Column field="fld_fu_done_by" header="FU Done by" body={(rowData) => cleanValue(rowData.fld_fu_done_by)} />
        <Column field="fld_pleasurable_activity_name" header="Pleasurable Activities" body={(rowData) => cleanValue(rowData.fld_pleasurable_activity_name)} />
        <Column field="fld_accomplishment_activity_name" header="Accomplishment Activities" body={(rowData) => cleanValue(rowData.fld_accomplishment_activity_name)} />

      </DataTable>
    </div>
  )
}

export default GetGoingActivity_7